<template src="./Grid.html"></template>
<style scoped src="./Grid.scss" lang="scss"></style>
<script>
import GridRow from "./GridRow";
const _ = require("lodash");
// import { mapGetters } from "vuex";

export default {
  name: "Grid",
  props: {
    // videos: Array,
    // categorias: Array
  },
  data() {
    return {
      selectedRowIndex: -1
    };
  },
  computed: {
    categorias: function() {
      return this.$store.getters.categories;
    }
  },
  components: {
    "app-row": GridRow
  },
  methods: {
    //...mapGetters(["getTopicInfo"]),
    //no me funciona si tengo que pasar un ID que busque  //https://forum.vuejs.org/t/mapgetters-with-params/4790
    //...mapGetters({
    //   doGetTopicInfo: "getTopicInfo"
    // }),
    rowOpened: function(rowID, elementScrollPos) {

      let alturaExpandedAbierto = 0;

      //calcula la altura del elemento expanded que está abierto para corregir la posicion del scroll
      //si hay alguno abierto
      if(this.selectedRowIndex >= 0){
        //solo necesito la correcion de scroll si el indice que abro es mayor que el que está abierto
        if(rowID > this.selectedRowIndex){
          alturaExpandedAbierto =  this.$refs.rows[this.selectedRowIndex].getExpandedHeight();
        }
      };

      this.selectedRowIndex = rowID;

      //abre el elemento y hace scroll teniendo en cuenta o no el tamaño de la caja que se cierra antes
      _.delay(() => {
        this.$refs.rows[this.selectedRowIndex].doExpandInfo(alturaExpandedAbierto);
      });
    },
    getVideoComponent: function(idVideo) {
    },
    rowBtnClosedClicked: function() {
      //cierre por aspa / interno, no porque se abrá otro row
      this.selectedRowIndex = -1;
    },
    logVideos: () => {
    },
    getVideosCategoria(categoria) {
      let videos = [];
      categoria.videos.forEach(idVideo => {
        videos.push(this.$store.getters.getTopicInfo(idVideo));
        // videos.push(this.getTopicInfo(idVideo));
      });
      return videos;
    }
  }
};
</script>
